import * as React from 'react';
import { IDecision, IOperator, DOMHelper, IBranch, EModalType } from '../../helpers';
import { Branch, BranchEdit } from '../';
import {
	Button, ButtonType, IDropdownOption
} from 'office-ui-fabric-react';
import store from '../../store/store';
import types from '../../store/types';

interface IProps {
	decision: IDecision;
	operators: IOperator[];
	operatorTypes: string[];
	outputOptions: IDropdownOption[];
	branchEditIndex: number;
	editedBranch: IBranch;
	addBranch: () => void;
	saveEditedBranch: () => void;
	updateEditedBranch: (branch: IBranch) => void;
	deleteBranch: (index: number) => void;
	setBranchEditIndex: (branchIndex: number) => void;
	branchIndex?: number;
	addOnly?: boolean;
	removeOnly?: boolean;
	overviewOnly?: boolean;
	closeDialog?: (save?: boolean) => void;
	toggleDecisionConfigDialog?: (componentId: string, previousOutputBlocks: any) => void;
	componentId?: string;
	previousOutputBlocks?: any;
	addBranchOnly?: () => void;
	removeBranchOnly?: (index: number, componentId: string) => void;

	conditions?: IBranch[];
	showBranchEdit?: boolean;
	changeShowBranchEdit?: (val?: boolean) => void;
}

export class Branches extends React.Component<IProps, any> {

	public componentDidUpdate(prevProps) {

		DOMHelper.setDropdownPropertyTabIndex();

	}

	decisionConfigDialogToggle() {

		// let {
		// 	componentId, previousOutputBlocks, toggleDecisionConfigDialog
		// } = this.props;
		// toggleDecisionConfigDialog(componentId, previousOutputBlocks);
		// store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

		// store.dispatch({
		// 	type: types.TOGGLE_DIALOG,
		// 	openModal: EModalType.None,
		// });

	}


	public render() {

		let items = [];
		let itemsOverview = [];
		let {
			decision, operators, operatorTypes, outputOptions, saveEditedBranch, deleteBranch,
			branchEditIndex, editedBranch, setBranchEditIndex, updateEditedBranch, branchIndex, addOnly,
			closeDialog, addBranch, addBranchOnly, removeBranchOnly, removeOnly, overviewOnly,
			toggleDecisionConfigDialog, componentId, previousOutputBlocks, conditions, showBranchEdit, changeShowBranchEdit
		} = this.props;
		// let branches = decision.Branches;
		let branches = conditions ? conditions : decision.Branches;

		if (branchIndex >= 0) {
			for (let i = 0; i < branches.length; i++) {
				if (i === branchIndex) {
					if (i === branchEditIndex &&
						store.getState().modalState.decisionConfig.componentId === componentId &&
						showBranchEdit) {
						items.push(
							<div className='branch-wrapper' key={"branch_" + i}>
								<BranchEdit
									branch={editedBranch}
									operators={operators}
									operatorTypes={operatorTypes}
									outputOptions={outputOptions}
									updateEditedBranch={updateEditedBranch}
									saveEditedBranch={saveEditedBranch}
									setBranchEditIndex={setBranchEditIndex}
									branchIndex={branchIndex}
									componentId={componentId}
									closeDialog={closeDialog}
									changeShowBranchEdit={changeShowBranchEdit}

								/>
							</div>
						);
						itemsOverview.push(
							<div className='branch-wrapper child-branch-wrapper' key={"branch_" + i}>
								<span>{branches[i].Name}</span>
							</div>
						);

					}
					else {
						items.push(
							<div className='branch-wrapper' key={"branch_" + i}>
								<Branch
									branch={branches[i]}
									operators={operators}
									operatorTypes={operatorTypes}
									outputOptions={outputOptions}
									deleteBranch={deleteBranch}
									setBranchEditIndex={setBranchEditIndex}
									canDeleteBranch={false}
									index={i}
									toggleDecisionConfigDialog={toggleDecisionConfigDialog}
									componentId={componentId}
									previousOutputBlocks={previousOutputBlocks}
									changeShowBranchEdit={changeShowBranchEdit}

								/>
							</div>
						);
						itemsOverview.push(
							<div className='branch-wrapper child-branch-wrapper' key={"branch_" + i}>
								<span>{branches[i].Name}</span>
							</div>
						);

					}
				}
			}

		}
		else {
			for (let i = 0; i < branches.length; i++) {

				if (i === branchEditIndex) {
					items.push(
						<div className='branch-wrapper' key={"branch_" + i}>
							<BranchEdit
								branch={editedBranch}
								operators={operators}
								operatorTypes={operatorTypes}
								outputOptions={outputOptions}
								updateEditedBranch={updateEditedBranch}
								saveEditedBranch={saveEditedBranch}
								setBranchEditIndex={setBranchEditIndex}
								branchIndex={branchIndex}
								closeDialog={closeDialog}
							/>
						</div>
					);
					itemsOverview.push(
						<div className='branch-wrapper child-branch-wrapper' key={"branch_" + i}>
							<span>{branches[i].Name}</span>
						</div>
					);

				}
				else {
					items.push(
						<div className='branch-wrapper' key={"branch_" + i}>
							<Branch
								branch={branches[i]}
								operators={operators}
								operatorTypes={operatorTypes}
								outputOptions={outputOptions}
								deleteBranch={deleteBranch}
								setBranchEditIndex={setBranchEditIndex}
								canDeleteBranch={branches.length > 1}
								index={i}
								changeShowBranchEdit={changeShowBranchEdit}
							/>
						</div>
					);
					itemsOverview.push(
						<div className='branch-wrapper child-branch-wrapper' key={"branch_" + i}>
							<span>{branches[i].Name}</span>
						</div>
					);

				}

			}

		}

		return (
			addOnly ?
				// <Button
				// 	buttonType={ButtonType.icon}
				// 	icon='Add'
				// 	title='Add'
				// 	className={'action add-search'}
				// 	tabIndex={branches.length * 5 + 2}
				// 	// onClick={this.props.addBranch}
				// 	onClick={() => {
				// 		this.decisionConfigDialogToggle();
				// 		addBranch();
				// 		closeDialog(true);
				// 	}}
				// />

				<div className="branches component">
					{/* {items} */}
					{branchIndex >= 0 ? null
						:
						<Button
							buttonType={ButtonType.icon}
							icon='Add'
							title='Add a decision branch'
							className={'action add-search badge-circle'}
							tabIndex={branches.length * 5 + 1}
							onClick={() => {
								// if (store.getState().modalState.decisionConfig.branchEditIndex === null) {
								toggleDecisionConfigDialog(componentId, previousOutputBlocks);
								addBranchOnly();
								closeDialog(true);
								// }

							}}
						/>
					}
				</div>

				:
				removeOnly ?
					<div className="branches branches-header-btn">
						{/* {items} */}
						{branchIndex >= 0 ?
							<Button
								buttonType={ButtonType.icon}
								icon='Delete'
								title='Delete this branch'
								className={'action '}
								tabIndex={branches.length * 5 + 1}
								onClick={(event) => {
									// The closeDialog method may be executed before the dialog confirmation. You may find the save implementation after dialog confirmation.
									toggleDecisionConfigDialog(componentId, previousOutputBlocks);
									removeBranchOnly(branchIndex, componentId), () => {
										closeDialog(true);
									};
									event.stopPropagation();

								}}
							/>
							: null
						}
					</div>

					:
					overviewOnly ?
						<div className="branches">
							<h4>Decision Branches: </h4>
							{itemsOverview}

						</div>
						:
						<div className="branches">
							{items}
							{branchIndex >= 0 ? null
								:
								<Button
									buttonType={ButtonType.icon}
									icon='Add'
									title='Add'
									className={'action add-search'}
									tabIndex={branches.length * 5 + 1}
									onClick={this.props.addBranch}
								/>
							}
						</div>
		);
	}

};


// WEBPACK FOOTER //
// ./source/ts/components/decisions/branches.tsx